export function activityToDeactivated(value: string): boolean | undefined {
  let activityToDeactivatedOutcome: boolean | undefined;
  if (value === "active") {
    activityToDeactivatedOutcome = false;
  } else {
    if (value === "deactivated") {
      activityToDeactivatedOutcome = true;
    } else {
      activityToDeactivatedOutcome = undefined;
    }
  }
  return activityToDeactivatedOutcome;
}
